import React from 'react';
import css from '../styles/area-housing.css';

const { Component } = React;

class AreaHousing extends Component {
  render() {
    return (
      <div className="areas-grid-item areas-grid-item--housing"> 
        <div class="areas-grid-item__wrapper">
          <div class="areas-area__hero">
          </div>
          <div class="areas-area__hero-text" data-aos="zoom-in" data-aos-anchor=".areas-grid-item--housing">
            <h3>Affordable Housing</h3>
            <p>LURAs (Land Use Restriction Agreements), Grant Applications, CHDO (Community Housing Development Organization) qualification, Fair Housing</p>
          </div>
        </div>
      </div>
    );
  }
}

export { AreaHousing };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-housing.js